// extracted by mini-css-extract-plugin
export default {"todoForm":"TodoForm_todoForm__jK-Tj","editForm":"TodoForm_editForm__IRUUv"};